import React, { useContext, useEffect, useRef, useState } from 'react';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import {
  Card,
  Typography,
  Button,
  makeStyles,
  useMediaQuery,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { ArrowBack, ArrowForward } from '@material-ui/icons';
import AmericanExpress from 'src/assets/payment/american-express.svg';
import MasterCard from 'src/assets/payment/mastercard.svg';
import VisaCard from 'src/assets/payment/visa.svg';
import {
  CardOnFile,
  RequestConfirmAppointment,
  ResponseAppointment,
  ResponseSignin,
} from 'src/types';
import {
  confirmAppointment,
  confirmCardOnFile,
  confirmKlarnaAppointment,
  createKlarnaIntent,
} from 'src/api/quote';
import postError from 'src/api/error';
import { setAppointment, setAuthToken } from 'src/store/actions';
import { callAdsBooking } from 'src/utils/ads';
import mixPanel from 'src/utils/mixpanel';
import { MIXPANEL_TRACK_FUNNEL_V2 } from 'src/utils/consts';
import CheckoutForm from 'src/views/Quote/components/Modals/ModalFinishBooking/CheckoutForm';
import { IReduxState } from 'src/store/reducers';
import callApi from 'src/api/request';
import { useSnackbar } from 'notistack';
import { signIn } from 'src/api/auth';
import { useDispatch, useSelector } from 'react-redux';
import KlarnaPromo from 'src/components/atoms/KlarnaPromo';
import { QuoteConfirmedContext } from './Context/QuoteConfirmedContext';
import QuoteSummaryMobile from '../atoms/QuotesummaryMobile';

interface PaymentStepProps {
  onNext: () => void;
  onBack: () => void;
  onComplete: () => void;
  hideBack: boolean;
}

const useStyles = makeStyles((theme) => ({
  cardOnFile: {
    padding: 16,
    background: '#E6EEEE',
    borderRadius: 8,
    border: '1px solid var(--blue-50, #227596)',
    marginTop: 20,
    fontFamily: 'Inter',
    '& .MuiTypography-body1': {
      fontFamily: 'Inter',
    },
  },
  Diagnosescard: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 50,
    background: '#fff',
  },
  clock: {
    marginTop: 30,
    width: 80,
    height: 80,
    flexShrink: 0,
    color: '#005959',
  },
  buttonForward: {
    color: '#fff',
    margin: '0px 20px 20px 20px',
    padding: '6px 24px',
    fontFamily: 'inter',
    borderRadius: '32px',
    textTransform: 'none',
  },
  li: {
    color: '#005959',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    maxWidth: 600,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 50,
  },
  greenCard: {
    backgroundColor: '#005959',
    padding: '24px 16px',
    flex: 1,
    marginBottom: 0,
    color: '#fff',
  },
  whiteCard: {
    paddingTop: 15,
    marginTop: 0,
    backgroundColor: theme.palette.common.white,
    flex: 1,

    boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.06)',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  mobileRoot: {
    width: '100%',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContent: {
    background: '#fff',
    padding: theme.spacing(3),
    outline: 'none',
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  modalTitle: {
    marginBottom: theme.spacing(2),
  },
  card: {
    marginBottom: theme.spacing(2),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
  },
  Hdiv: {
    display: 'flex',
    flexDirection: 'row',
  },
  customFontHead: {
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Inter',

    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '30px',
    marginTop: 40,
  },
  customFontSub: {
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '30px',
    marginTop: 10,
  },
  customTabs: {
    '& .MuiTabs-fixed': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiTabs-indicator': {
      display: 'none !important',
    },

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
  },
  tab1: {
    alignSelf: 'start',
    borderRadius: 8,
    width: '50%',
    color: '#1A5B74',
    fontWeight: 700,
    border: '1px solid var(--blue-50, #227596)',
    '& .PrivateTabIndicator-colorPrimary-64': {
      background: '#fff',
    },
    '& .MuiTab-wrapper': {
      textAlign: 'left',
      display: 'flex',

      textTransform: 'none',

      alignItems: 'start',
    },
    fontFamily: 'Inter',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      width: '60%',
    },
  },
  tab1notSelected: {
    alignSelf: 'start',
    borderRadius: 8,
    fontWeight: 700,
    width: '50%',
    color: '#646867',
    border: '1px solid var(--blue-50, #D4D5D5)',
    '& .PrivateTabIndicator-colorPrimary-64': {
      background: '#fff',
    },
    '& .MuiTab-wrapper': {
      textAlign: 'left',
      display: 'flex',

      textTransform: 'none',

      alignItems: 'start',
    },
    fontFamily: 'Inter',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      width: '60%',
    },
  },

  tab2: {
    alignSelf: 'end',
    borderRadius: 8,
    fontWeight: 700,
    fontFamily: 'Inter',
    color: '#1A5B74',
    border: '1px solid var(--blue-50, #227596)',
    '& .PrivateTabIndicator-colorPrimary-64': {
      background: '#fff',
    },

    '& .MuiTab-wrapper': {
      textAlign: 'left',
      display: 'flex',
      textTransform: 'none',

      alignItems: 'start',
    },
    width: '50%',

    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      width: '60%',
    },
  },
  tab2notSelected: {
    alignSelf: 'end',
    borderRadius: 8,
    color: '#646867',
    fontWeight: 700,
    fontFamily: 'Inter',
    border: '1px solid var(--blue-50, #D4D5D5)',
    '& .PrivateTabIndicator-colorPrimary-64': {
      background: '#fff',
    },

    '& .MuiTab-wrapper': {
      textAlign: 'left',
      display: 'flex',
      textTransform: 'none',

      alignItems: 'start',
    },
    width: '50%',

    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      width: '60%',
    },
  },
  reservationButton: {
    borderRadius: 31,
    textTransform: 'none',
    margin: '20px auto',
    boxShadow: 'none',
    width: '100%',
    padding: theme.spacing(2),
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    '& .MuiButton-label': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  },
}));

const PaymentStep: React.FC<PaymentStepProps> = ({
  onNext,
  onBack,
  onComplete,
  hideBack,
}) => {
  const { QuoteConfirmed, setQuoteConfirmed } = useContext(
    QuoteConfirmedContext
  );

  const classes = useStyles();
  const dispatch = useDispatch();
  const appointment = useSelector(
    (state: IReduxState) => state.quote.appointment
  );
  const { enqueueSnackbar } = useSnackbar();
  const [errors, setErrors] = useState<string | undefined | null>(null);
  const [stripeRequestInProgress, setStripeRequestInProgress] = useState(false);
  const [klarnaError, setKlarnaError] = useState<string | undefined>();
  const [paymentTotal, setPaymentTotal] = useState<number>(0);
  const [message, setMessage] = useState<string | undefined>();
  const [isCardOnFile, setIsCardOnFile] = useState<boolean>(false);
  const [requestInProgress, setRequestInProgress] = useState(false);
  const [klarnaRequestInProgress, setKlarnaRequestInProgress] = useState(false);
  const [klarnaInitializing, setKlarnaInitializing] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState<string>('card');
  const [lastFour, setLastFour] = useState<string>('');
  const [cardBrand, setCardBrand] = useState<string>('');
  const [prevCardSelected, setPrevCardSelected] = useState(false);
  const [errorCardOnFile, setErrorCardOnFile] = useState<
    string | undefined | null
  >(null);
  const klarnaReturnHandled = useRef(false);
  const klarnaIntentRequestedFor = useRef<string | null>(null);

  const login = async (resp: ResponseAppointment) => {
    const response: ResponseSignin = await signIn(
      {
        id: `${resp.data && resp.data.id}`,
      },
      true
    );

    if (response && response.auth_token && response.user && response.user.id) {
      dispatch(
        setAuthToken(response.auth_token, response.user.id, response.user.email)
      );

      onComplete();
      onNext();
    } else {
      setStripeRequestInProgress(false);
      setErrors('Invalid payment information');
    }
  };

  const handleCheckboxChange = () => {
    setPrevCardSelected(!prevCardSelected);
  };

  const showCommonError = (msg?: string | undefined) => {
    const errorMsg: string =
      msg || 'An error occured while processing your quote.';
    enqueueSnackbar(errorMsg, {
      variant: 'error',
      anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
    });
  };

  const handleConfirmCardOnFile = async () => {
    if (!appointment?.id) {
      return;
    }

    setRequestInProgress(true);

    confirmCardOnFile(appointment?.id)
      .then((resp: ResponseAppointment) => {
        if (resp.errors) {
          showCommonError(resp.errors.join('. '));
          setRequestInProgress(false);
        } else {
          dispatch(setAppointment(resp.data));
          callAdsBooking(resp.data);
          login(resp);
        }
      })
      .catch(() => {
        showCommonError();
        setRequestInProgress(false);
      })
      .finally(() => setRequestInProgress(false));
  };

  useEffect(() => {
    const userId = appointment?.attributes.user_id;

    if (userId) {
      callApi<CardOnFile>({
        url: `/api/v2/user/card_on_file/${userId}`,
        method: 'GET',
      }).then((response) => {
        if (response.errors && response.errors.length > 0) {
          setErrorCardOnFile(
            'An error occurred while processing your request.'
          );
        } else if (
          response.card_on_file?.card_brand &&
          response.card_on_file?.last_4_digits
        ) {
          setIsCardOnFile(true);
          setLastFour(response.card_on_file?.last_4_digits as string);
          setCardBrand(response.card_on_file?.card_brand);
        }
      });
    }
  }, [appointment?.attributes.user_id]);

  const stripe = useStripe();
  const elements = useElements();

  const isSm = useMediaQuery('(max-width: 1300px)');

  const clearKlarnaParams = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('payment_intent');
    url.searchParams.delete('payment_intent_client_secret');
    url.searchParams.delete('redirect_status');
    window.history.replaceState({}, document.title, url.toString());
  };

  const handleCheckOut = async () => {
    setStripeRequestInProgress(true);
    setErrors(null);

    if (!appointment?.id) {
      setErrors(
        'There was an error processing your payment. Please try again.'
      );
      setStripeRequestInProgress(false);
      return false;
    }

    if (!stripe || !elements) {
      setErrors('Payment form is still loading. Please try again.');
      setStripeRequestInProgress(false);
      return false;
    }

    const cardElem = elements.getElement(CardElement);

    if (!cardElem) {
      setErrors('Payment form is still loading. Please try again.');
      setStripeRequestInProgress(false);
      return false;
    }

    const { token, error } = await stripe.createToken(cardElem);

    if (error) {
      setErrors(error.message || 'Invalid payment information.');
      setStripeRequestInProgress(false);
      return false;
    }

    if (!token) {
      setErrors('Invalid payment information.');
      setStripeRequestInProgress(false);
      return false;
    }

    const data: RequestConfirmAppointment = {
      token: token.id,
    };

    await confirmAppointment(appointment.id, data)
      .then((resp: ResponseAppointment) => {
        if (resp.errors) {
          setErrors(resp.errors.join(', '));
          setStripeRequestInProgress(false);
        } else {
          dispatch(setAppointment(resp.data));
          callAdsBooking(resp.data);
          setStripeRequestInProgress(false);
          onComplete();
          onNext();
          mixPanel(MIXPANEL_TRACK_FUNNEL_V2.NF_CARD_INFO);
        }
      })
      .catch(() => {
        setErrors(
          'There was an error processing your payment. Please try again.'
        );
        setStripeRequestInProgress(false);
      });

    setStripeRequestInProgress(false);

    return true;
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirectStatus = params.get('redirect_status');
    const paymentIntentId = params.get('payment_intent');

    if (
      !appointment?.id ||
      !redirectStatus ||
      !paymentIntentId ||
      klarnaReturnHandled.current
    ) {
      return;
    }

    if (redirectStatus !== 'succeeded') {
      setKlarnaError('Klarna authorization was not completed.');
      clearKlarnaParams();
      klarnaReturnHandled.current = true;
      return;
    }

    klarnaReturnHandled.current = true;
    setKlarnaRequestInProgress(true);
    setKlarnaError(undefined);

    confirmKlarnaAppointment(appointment.id, paymentIntentId)
      .then((resp: ResponseAppointment) => {
        if (resp.errors) {
          setKlarnaError(resp.errors.join('. '));
          return;
        }

        dispatch(setAppointment(resp.data));
        callAdsBooking(resp.data);
        clearKlarnaParams();
        login(resp);
      })
      .catch(() => {
        setKlarnaError('There was an error finalizing your Klarna payment.');
        clearKlarnaParams();
      })
      .finally(() => {
        setKlarnaRequestInProgress(false);
      });
  }, [appointment?.id, dispatch]);

  // Klarna is only offered once the job has an estimate; a diagnosis-only
  // booking with no estimate pays by card.
  const showKlarnaOption =
    Boolean(appointment?.attributes?.estimate) && paymentTotal > 0;

  useEffect(() => {
    if (!appointment?.id || !showKlarnaOption) {
      return;
    }

    if (appointment.attributes.payment_intent_secret) {
      return;
    }

    const requestKey = `${appointment.id}:${paymentTotal}`;
    if (klarnaIntentRequestedFor.current === requestKey) {
      return;
    }

    klarnaIntentRequestedFor.current = requestKey;
    setKlarnaInitializing(true);

    createKlarnaIntent(appointment.id)
      .then((response) => {
        if (response.errors) {
          setKlarnaError(response.errors.join('. '));
          klarnaIntentRequestedFor.current = null;
          return;
        }

        dispatch(setAppointment(response.data));
        setKlarnaError(undefined);
      })
      .catch(() => {
        setKlarnaError('There was an error preparing Klarna.');
        klarnaIntentRequestedFor.current = null;
      })
      .finally(() => {
        setKlarnaInitializing(false);
      });
  }, [
    appointment?.attributes?.appointment_type,
    appointment?.attributes?.payment_intent_secret,
    appointment?.id,
    dispatch,
    paymentTotal,
    showKlarnaOption,
  ]);

  const handleKlarnaCheckout = async () => {
    if (!appointment?.id || !stripe) {
      setKlarnaError('Payment form is still loading. Please try again.');
      return;
    }

    setKlarnaRequestInProgress(true);
    setKlarnaError(undefined);

    try {
      let clientSecret = appointment.attributes.payment_intent_secret;

      if (!clientSecret) {
        const response = await createKlarnaIntent(appointment.id);

        if (response.errors) {
          setKlarnaError(response.errors.join('. '));
          return;
        }

        dispatch(setAppointment(response.data));
        clientSecret = response.data.attributes.payment_intent_secret;
      }

      if (!clientSecret) {
        setKlarnaError('Unable to initialize Klarna.');
        return;
      }

      const result = await (
        stripe as unknown as {
          confirmKlarnaPayment: (
            secret: string,
            data: {
              payment_method: {
                billing_details: {
                  email?: string;
                  name?: string;
                  address: {
                    country: string;
                    postal_code?: string;
                    line1?: string;
                  };
                };
              };
              return_url: string;
            }
          ) => Promise<{
            error?: { message?: string };
            paymentIntent?: { id: string; status?: string };
          }>;
        }
      ).confirmKlarnaPayment(clientSecret, {
        payment_method: {
          billing_details: {
            email: appointment.attributes.customer_email,
            name: appointment.attributes.customer_name,
            address: {
              country: 'US',
              postal_code: appointment.attributes.address,
              line1: appointment.attributes.exact_address,
            },
          },
        },
        return_url: `${window.location.origin}${window.location.pathname}`,
      });

      if (result?.error?.message) {
        setKlarnaError(result.error.message);
        return;
      }

      if (
        result?.paymentIntent?.id &&
        ['requires_capture', 'succeeded'].includes(
          result.paymentIntent.status || ''
        )
      ) {
        const finalizedResponse = await confirmKlarnaAppointment(
          appointment.id,
          result.paymentIntent.id
        );

        if (finalizedResponse.errors) {
          setKlarnaError(finalizedResponse.errors.join('. '));
          return;
        }

        dispatch(setAppointment(finalizedResponse.data));
        callAdsBooking(finalizedResponse.data);
        login(finalizedResponse);
      }
    } catch (error) {
      setKlarnaError('There was an error starting Klarna. Please try again.');
    } finally {
      setKlarnaRequestInProgress(false);
    }
  };

  useEffect(() => {
    const getPaymentTotal = () => {
      let price = 0;

      if (appointment?.attributes.appointment_type === 'diagnosis') {
        const diagPrice = appointment?.attributes.member_job
          ? appointment?.attributes.diagnosis_price_member
          : appointment?.attributes.diagnosis_price;

        if (diagPrice) {
          price += diagPrice;
        }
      }

      if (appointment?.attributes.estimate) {
        const servicePrice = appointment?.attributes.member_job
          ? appointment?.attributes.estimate.total_member_price
          : appointment?.attributes.estimate.total_price;

        if (servicePrice) {
          price += servicePrice;
        }
      }

      return price || 0;
    };

    setPaymentTotal(getPaymentTotal() || 0);
  }, [
    appointment?.attributes.diagnosis_price,
    appointment?.attributes.diagnosis_price_member,
    appointment?.attributes.appointment_type,
    appointment?.attributes.member_job,
    appointment?.attributes.estimate,
  ]);

  return (
    <>
      <>
        {hideBack ? (
          <div style={{ height: 50 }} />
        ) : (
          <Button
            className={classes.buttonForward}
            style={{
              color: '#005959',
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              margin: '0px 0px 20px 0px',
            }}
            onClick={() => {
              onBack();
            }}
          >
            <ArrowBack
              style={{
                width: 20,
                height: 20,
                marginTop: 'auto',
                marginBottom: 'auto',
              }}
            />{' '}
            <Typography
              style={{
                margin: 'auto 0 auto 10px',
                fontSize: 16,
                fontFamily: 'Inter',
              }}
            >
              Back
            </Typography>
          </Button>
        )}
        <Card
          style={{
            minWidth: 0,
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: isSm ? 20 : 0,
            padding: isSm ? '20px 0' : '28px 0',
            background: '#fff',
            width: '100%',
          }}
          elevation={0}
        >
          {isSm && <QuoteSummaryMobile />}
          <Card
            style={{
              background: '#fff',
              padding: isSm ? '24px 20px' : '32px 28px',
              minWidth: 0,
              width: '100%',
              borderRadius: '8px',
            }}
            elevation={0}
          >
            <img
              src={VisaCard}
              alt="Credit Card"
              style={{
                width: 50,
                marginBottom: 20,
                marginRight: 10,
              }}
            />
            <img
              src={MasterCard}
              alt="Credit Card"
              style={{
                width: 30,
                marginBottom: 20,
                marginRight: 10,
              }}
            />
            <img
              src={AmericanExpress}
              alt="Credit Card"
              style={{
                width: 50,
                marginBottom: 20,
              }}
            />
            <Typography
              style={{
                fontSize: 26,
                fontFamily: 'Inter',
                fontWeight: 600,
                marginBottom: 15,
              }}
            >
              Confirm Payment
            </Typography>
            <Typography
              style={{
                fontSize: 16,
                fontFamily: 'Inter',
                fontWeight: 400,

                display: 'flex',
                flexDirection: 'row',
              }}
            >
              Confirm appointment details.{' '}
            </Typography>
            <Typography
              style={{
                fontSize: 16,
                fontFamily: 'Inter',
                fontWeight: 600,
                marginBottom: 15,
              }}
            >
              You won&apos;t be charged until the day of service. &nbsp;
            </Typography>{' '}
            {showKlarnaOption && (
              <div style={{ marginTop: 24, marginBottom: 24 }}>
                <KlarnaPromo amount={paymentTotal} compact />
              </div>
            )}
            {showKlarnaOption && (
              <RadioGroup
                value={showKlarnaOption ? selectedPaymentMethod : 'card'}
                onChange={(event) => {
                  setKlarnaError(undefined);
                  setSelectedPaymentMethod(event.target.value);
                }}
                style={{ display: 'flex', gap: 20, flexDirection: 'row' }}
              >
                <FormControlLabel
                  value="card"
                  control={<Radio style={{ color: '#005959' }} />}
                  label={
                    <Typography style={{ fontFamily: 'Inter' }}>
                      Card
                    </Typography>
                  }
                />
                {showKlarnaOption && (
                  <FormControlLabel
                    value="klarna"
                    control={<Radio style={{ color: '#005959' }} />}
                    label={
                      <Typography style={{ fontFamily: 'Inter' }}>
                        Klarna
                      </Typography>
                    }
                  />
                )}
              </RadioGroup>
            )}
            {(selectedPaymentMethod !== 'klarna' || !showKlarnaOption) && (
              <>
                <div>
                  {isCardOnFile && (
                    <Card className={classes.cardOnFile} elevation={0}>
                      <Typography
                        style={{ fontFamily: 'Inter', fontWeight: 600 }}
                      >
                        Use card on file
                      </Typography>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={prevCardSelected}
                            onChange={handleCheckboxChange}
                            color="primary"
                          />
                        }
                        label={`${cardBrand} ending ${lastFour}`}
                      />
                    </Card>
                  )}

                  {!prevCardSelected && (
                    <CheckoutForm errors={errors} message={message} />
                  )}
                </div>
                <Button
                  onClick={
                    isCardOnFile && prevCardSelected
                      ? handleConfirmCardOnFile
                      : handleCheckOut
                  }
                  disabled={stripeRequestInProgress || requestInProgress}
                  style={{
                    background:
                      stripeRequestInProgress || requestInProgress
                        ? '#D4D5D5'
                        : '#005959',
                    marginTop: '35px',
                    marginLeft: '2px',
                    color: '#fff',
                  }}
                  className={classes.buttonForward}
                  variant="contained"
                  size="large"
                >
                  Confirm Payment
                  {!stripeRequestInProgress && <ArrowForward />}
                </Button>
              </>
            )}
            {showKlarnaOption && selectedPaymentMethod === 'klarna' && (
              <Card
                style={{
                  width: '100%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  padding: 20,
                  background: '#fff',
                  marginTop: 20,
                  fontFamily: 'Inter',
                  borderRadius: '8px',
                  boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.06)',
                }}
                elevation={1}
              >
                <Typography style={{ fontFamily: 'Inter', marginBottom: 8 }}>
                  Continue with Klarna to authorize your payment now and charge
                  it later.
                </Typography>
                {klarnaInitializing && (
                  <Typography style={{ marginTop: 8, fontFamily: 'Inter' }}>
                    Preparing Klarna...
                  </Typography>
                )}
                {klarnaError && (
                  <Typography
                    color="error"
                    style={{ marginTop: 8, fontFamily: 'Inter' }}
                  >
                    {klarnaError}
                  </Typography>
                )}
                <Button
                  onClick={handleKlarnaCheckout}
                  disabled={
                    klarnaInitializing ||
                    klarnaRequestInProgress ||
                    stripeRequestInProgress ||
                    requestInProgress ||
                    !appointment?.attributes.payment_intent_secret
                  }
                  style={{
                    background:
                      klarnaInitializing ||
                      klarnaRequestInProgress ||
                      stripeRequestInProgress ||
                      requestInProgress ||
                      !appointment?.attributes.payment_intent_secret
                        ? '#D4D5D5'
                        : '#005959',
                    marginTop: '20px',
                    marginLeft: '2px',
                    color: '#fff',
                  }}
                  className={classes.buttonForward}
                  variant="contained"
                  size="large"
                >
                  Continue with Klarna
                  {!klarnaRequestInProgress && !klarnaInitializing && (
                    <ArrowForward />
                  )}
                </Button>
              </Card>
            )}
          </Card>
        </Card>
      </>
    </>
  );
};

export default PaymentStep;
